export default __webpack_public_path__ + "static/media/imagem_posto.fd88f31b.png";